module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'n8wlyhko',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
